/**
 * Коды ошибок школьного входа (`?board_auth=…`), которые ставит
 * `GET /api/v1/auth/callback`. Показываются и на /school, и на /login —
 * старые ссылки на /login?board_auth=… всё ещё ходят по почте и закладкам.
 */
export const boardAuthMessages: Record<string, string> = {
  invalid_token: "Сессия с bez-part.ru истекла. Войдите на портале снова.",
  token_used:
    "Эта ссылка входа уже использована. Нажмите «Войти через bez-part.ru» ещё раз.",
  school_account_has_password:
    "У этой школьной строки на доске задан пароль, из-за чего школьный вход закрыт. Напишите в поддержку.",
  // Старый общий код: приходит от версий API до разделения причин.
  email_taken:
    "Ваш школьный email уже занят другой строкой на доске. Напишите в поддержку — это разово чинится на сервере.",
  conflict:
    "Ваш школьный email уже занят другой строкой на доске. Напишите в поддержку — это разово чинится на сервере.",
  rate_limit: "Слишком много попыток. Подождите и попробуйте снова.",
  unavailable: "Связка с bez-part.ru не настроена на сервере.",
  missing_token: "Не получен токен от bez-part.ru.",
  error: "Не удалось войти через bez-part.ru.",
};

export function boardAuthMessage(code: string | null | undefined): string | null {
  if (!code) return null;
  return boardAuthMessages[code] ?? null;
}
